export function buildAssistantMessageActionProps(props, vm, handlers) {
  const {
    showVersionNav,
    versionLabel,
    onPrevVersion,
    onNextVersion,
    prevDisabled,
    nextDisabled,
  } = props
  return {
    showVersionNav,
    versionLabel,
    onPrevVersion,
    onNextVersion,
    prevDisabled,
    nextDisabled,
    copied: vm.copied,
    handleCopy: vm.handleCopy,
    feedback: vm.feedback,
    ...handlers,
    retryMenuId: vm.retryMenuId,
    retryOpen: vm.retryOpen,
    menuId: vm.menuId,
    menuOpen: vm.menuOpen,
  }
}
